import React from 'react';
import ApolloClient from 'apollo-boost';
import { ApolloProvider } from '@apollo/react-hooks';
import Layout from '../../components/layout';
import SEO from '../../components/seo';
import { SettingProvider } from '../../lib/context/settings';
import { AdsProvider } from '../../lib/context/ads';
import { Button, Col, Row } from 'antd';
import styled from 'styled-components';
import { device } from '../../lib/theme';
import { Title } from '../../components/styles';

const client = new ApolloClient<any>({
  uri: `https://${process.env.GATSBY_WORDPRESS_URL_PATH}/graphql`,
  fetchOptions: {
    credentials: 'include',
  },
});

const HeroContainer = styled(Row)`
  background-image: url('https://aaacdndev.blob.core.windows.net/wordpress/2021/01/20-PD-0326-C-AEM-1200x400-bnr.png');
  background-size: cover;
  background-position: right;
  background-repeat: no-repeat;
  height: 340px;

  h1 {
    max-width: 80%;
    font-size: 32px;
    line-height: 1.1;
  }

  @media ${device.laptop} {
    h1 {
      max-width: 60%;
      font-size: 56px;
      line-height: 1.2;
    }

    background-position: center center;
  }
`;

const BusinessInsuranceLP: React.FC<any> = () => {
  return (
    <ApolloProvider client={client as any}>
      <SettingProvider>
        <AdsProvider>
          <Layout key={`${typeof window}`}>
            <SEO
              title="Commercial Insurance with AAA"
              description=""
              canonicalUrl="/landing/business-insurance/"
            />
            <Row style={{ marginTop: 64, marginBottom: 64 }}>
              <Col xs={{ span: 22, offset: 1 }} md={{ span: 20, offset: 2 }}>
                <Row>
                  <Col xs={{ span: 24 }} md={{ span: 12 }}>
                    <img
                      style={{ maxHeight: 150 }}
                      src="https://prod-carolinas-aaa-com.azurewebsites.net/wp-content/themes/aaawpmigrate/img/landing/aaa-ins-logo-only.png"
                    />
                    <br />
                    <Button
                      style={{ marginTop: 16 }}
                      type="primary"
                      href="tel:18006571548"
                    >
                      Call: 1-800-657-1548
                    </Button>
                    <Title style={{ marginTop: 16, marginBottom: 16 }}>
                      Quality Business Insurance Means Total Peace of Mind
                    </Title>
                    <p>
                      Not having the right business insurance coverage no matter
                      how big or small your company is can put you at risk. You
                      should be confident the insurance you purchase will
                      protect your business when you need it most.
                    </p>
                    <Button
                      style={{ marginTop: 16 }}
                      type="primary"
                      href="/insurance/products/business/quote/"
                    >
                      Get a Business Insurance Quote
                    </Button>
                  </Col>
                  <Col xs={{ span: 0 }} md={{ span: 11, offset: 1 }}>
                    {' '}
                    <img
                      style={{ width: '100%' }}
                      src="https://prod-carolinas-aaa-com.azurewebsites.net/wp-content/themes/aaawpmigrate/img/landing/com-insurance-stock.jpg"
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Layout>
        </AdsProvider>
      </SettingProvider>
    </ApolloProvider>
  );
};

export default BusinessInsuranceLP;
